import { render, staticRenderFns } from "./explosiveText.vue?vue&type=template&id=413e1a6a&scoped=true"
import script from "./explosiveText.vue?vue&type=script&lang=js"
export * from "./explosiveText.vue?vue&type=script&lang=js"
import style0 from "./explosiveText.vue?vue&type=style&index=0&id=413e1a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413e1a6a",
  null
  
)

export default component.exports